import { render, staticRenderFns } from "./UniteColoniesOrRemoveQueen.vue?vue&type=template&id=5ef550a8&scoped=true&"
import script from "./UniteColoniesOrRemoveQueen.vue?vue&type=script&lang=js&"
export * from "./UniteColoniesOrRemoveQueen.vue?vue&type=script&lang=js&"
import style0 from "./UniteColoniesOrRemoveQueen.vue?vue&type=style&index=0&id=5ef550a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef550a8",
  null
  
)

export default component.exports